import { Comment, FirebaseComment } from "../entities/comment";
import { db, doc, updateDoc, collection, getDocs } from "../../firebase";
import CommentRepository from "../usecases/ports/commentRepository";
import { data as constants } from "../../constants";
export default class CommentFirebaseImpl implements CommentRepository {
  updateComment = async (
    applicantId: string,
    id: string,
    data: Comment[]
  ): Promise<void> => {
    try {
      const commentsRef = doc(db, "applicant", applicantId, "comments", id);
      await updateDoc(commentsRef, { comments: data });
    } catch (error) {
      throw error;
    }
  };

  fetchComment = async (applicantId: string): Promise<FirebaseComment> => {
    try {
      let comment: any = [];
      const commentsRef = collection(db, "applicant", applicantId, "comments");
      const commentsDocData = await getDocs(commentsRef);
      if (commentsDocData.empty && commentsDocData.metadata.fromCache) {
        throw new Error(constants.commonNetworkError);
      }

      commentsDocData.forEach((doc) => {
        let data = doc.data();
        const formattedData = data.comments.map((commentData: any) => {
          return {
            dateTime: commentData.dateTime.toDate(),
            comment: commentData.comment,
            commentor: commentData.commentor,
          };
        });

        comment.push({ comment: formattedData, id: doc.id });
      });

      return comment[0];
    } catch (error) {
      throw error;
    }
  };
}
